import HundredBricksAPIError from '../../../HundredBricksAPIError';
class DiversificationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DiversificationError', ...args);
    }
}
export default DiversificationError;
